import { TimeAwareEncoder } from "./time-aware";
var PolylineUtils = /** @class */ (function () {
    function PolylineUtils() {
        this.encoder = new TimeAwareEncoder();
    }
    PolylineUtils.prototype.updateTimeAwarePolyline = function (encodedPolyline) {
        if (this.isNewPolyline(encodedPolyline)) {
            this.encodedPolyline = encodedPolyline;
            this.timeAwarePolyline = this.encoder.decodeTimeAwarePolyline(this.encodedPolyline);
        }
    };
    PolylineUtils.prototype.getPolylineToTime = function (timestamp) {
        return this.encoder.getLocationsElapsedByTimestamp(this.timeAwarePolyline, timestamp);
    };
    PolylineUtils.prototype.getLatestTime = function () {
        if (this.timeAwarePolyline) {
            var lastI = this.timeAwarePolyline.length - 1;
            return lastI > -1 ? this.timeAwarePolyline[lastI][2] : null;
        }
        else {
            return null;
        }
    };
    PolylineUtils.prototype.isNewPolyline = function (encodedPolyline) {
        return encodedPolyline != this.encodedPolyline;
    };
    return PolylineUtils;
}());
export { PolylineUtils };
//# sourceMappingURL=polyline.js.map